const ws = process.env.BASE_URL.api + '/ws'
let stompClient = null

export function subscribe(clientId, dest, headers, handler) {
  const socket = new SockJS(ws)
  stompClient = Stomp.over(socket)
  stompClient.connect(headers || {}, function () {
    stompClient.subscribe('/clients/' + clientId + dest, function (message) {
      handler(JSON.parse(message.body))
    })
  })
}

export function disconnect(resolve) {
  resolve = resolve || function () { }
  if (stompClient) {
    stompClient.disconnect(resolve)
  } else {
    resolve()
  }
}



// WEBPACK FOOTER //
// ./src/api/socket.js